var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyactivityFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#5A7ED7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1185_2714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15.7,
    width: 21.6,
    height: 24.3,
    rx: 2.7,
    fill: "#FFD77C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8523 13H21.7523C21.0068 13 20.4023 13.6044 20.4023 14.35V17.05C20.4023 17.7956 21.0068 18.4 21.7523 18.4H29.8523C30.5979 18.4 31.2023 17.7956 31.2023 17.05V14.35C31.2023 13.6044 30.5979 13 29.8523 13Z",
    fill: "#794142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4023 34.6H21.7523",
    stroke: "#3361CF",
    strokeWidth: 2.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.475 24.637C34.745 24.367 35.0555 24.1645 35.393 24.016C35.7305 23.8675 36.1085 23.8 36.473 23.8C36.8375 23.8 37.2155 23.8675 37.553 24.016C37.8905 24.1645 38.2145 24.367 38.471 24.637C38.741 24.907 38.9435 25.2175 39.092 25.555C39.2405 25.8925 39.308 26.2705 39.308 26.635C39.308 26.9995 39.2405 27.3775 39.092 27.715C38.9435 28.0525 38.741 28.3765 38.471 28.633L32.477 34.6L27.1445 35.95L28.481 30.6175L34.4615 24.6235L34.475 24.637Z",
    fill: "#EE7234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5168 34.519L27.1523 35.9635L28.6238 35.5855L27.5168 34.519Z",
    fill: "#3361CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1185_2714",
    x: 9.6,
    y: 13,
    width: 35.1125,
    height: 37.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_2714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_2714",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyactivityFilled);
export default __webpack_public_path__ + "static/media/my activity_filled.10eda1858e773ca352838e4091843add.svg";
export { ForwardRef as ReactComponent };